<template>
  <proa-modal
    :modal="modal"
    :title="$t('models.taskCard.attributes.projectLabelIds')"
    @close="$emit('close')"
  >
    <div
      v-for="projectLabel in projectLabelOptions"
      :key="projectLabel.id"
      class="project-label-wrapper"
    >
      <proa-check-box
        :model="selectedProjectLabels"
        :value="projectLabel.value"
        @change="newModel => { selectedProjectLabels = newModel }"
      >
        <span
          class="project-label"
          :style="[{
            'background-color': projectLabel.color ,
            'color': projectLabel.color ? '#fff' : '#000',
            'padding': projectLabel.color ? '5px 10px 5px 5px' : '0'
          }]"
        >
          {{ projectLabel.label }}
        </span>
      </proa-check-box>
    </div>
    <template slot="footer">
      <proa-button
        @click.native="$emit('close')"
        class="default-button-width mr-2"
      >
        {{ $t('common.cancel') }}
      </proa-button>
      <proa-button
        @click.native="$emit('onUpdateProjectLabelIds', selectedProjectLabels)"
        class="default-button-width"
      >
        {{ $t('common.ok') }}
      </proa-button>
    </template>
  </proa-modal>
</template>

<script>
import i18n from '@/i18n'

export default {
  name: 'EditProjectTaskCardProjectLabelCheckBoxModal',
  props: {
    projectLabelIds: Array,
    projectLabels: Array,
    modal: Boolean
  },
  computed: {
    projectLabelOptions: function() {
      return [{
        label: i18n.tc('models.taskCard.placeHolders.projectLabelIds'),
        value: null
      }, ...this.projectLabels.map((projectLabel) => {
        const currentProjectLabel = projectLabel.id == this.projectLabelIds[0]
        return {
          label: projectLabel.title,
          color: projectLabel.color,
          value: projectLabel.id,
          selected: currentProjectLabel,
          disabled: currentProjectLabel
        }
      })]
    }
  },
  data() {
    return {
      selectedProjectLabels: [],
      innerProjectLabelIds: []
    }
  },
  methods: {
    initProjectLabelIds: function() {
      this.selectedProjectLabels = this.projectLabelIds.slice()
    },
    checkNullInArray: function () {
      let checkedNull = this.selectedProjectLabels.filter((selectedProjectLabel) => {
        return selectedProjectLabel === null
      })

      if (this.selectedProjectLabels[0] === null && this.selectedProjectLabels.length > 1) {
        let checkedWithoutNull = this.selectedProjectLabels.filter((selectedProjectLabel) => {
          return selectedProjectLabel !== null
        })
        return this.selectedProjectLabels = checkedWithoutNull
      }

      if (checkedNull[0] === null && this.selectedProjectLabels.length > 1) {
        this.selectedProjectLabels = [null]
      } else {
        return this.selectedProjectLabels
      }
    }
  },
  watch: {
    modal: function(value) {
      if (!value) return
      this.initProjectLabelIds()
    },
    selectedProjectLabels: function(value) {
      if (!value.includes(null)) return
      this.checkNullInArray()
    }
  }
}
</script>

<style scoped lang="scss">
.project-label-wrapper {
  margin-bottom: 10px;
  .project-label {
    font-weight: 600;
    border-radius: 2px;
  }
}
</style>
